define("settings/components/social-set-upgrade", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.isMobileSubscription}}
    {{#if this.displayMobileUpgrade}}
      <div class="cIC--card u--m__t__xs">
        <div class="cIC--cardBody u--p__t__sm">
          {{this.mobileUpgradeText}}
          <Shared::Ui::Button
            @class="u--p__0 u--text--hl"
            @text={{t "shared_phrases.learn_more"}}
            @variant="unstyled"
            onClick={{this.openMobileRedirectModal}}
          />
        </div>
      </div>
    {{/if}}
  {{else}}
    {{#if (not this.canAddSocialSets)}}
      <Shared::Button::Upgrade
        @additional="block"
        @feature="addSocialSets"
        @location="account social sets"
        @variant="unstyled"
        as |upgradeAction|
      >
        <Shared::Ui::Button
          @additional="block"
          @onClick={{upgradeAction}}
          @variant="actionLink"
          class="u--text--success u--p__0 u--m__0"
        >
          {{#if this.currentAccount.canTrialPlan}}
            {{t "account.groups.social_sets.upgrade_trial"}}
          {{else}}
            {{t "account.groups.social_sets.upgrade"}}
          {{/if}}
        </Shared::Ui::Button>
      </Shared::Button::Upgrade>
    {{else if (eq @socialSetsRemaining 0)}}
      <Shared::Button::Upgrade
        @additional="block"
        @feature="socialSet"
        @location="account social sets"
        @text={{t "account.groups.social_sets.add_more"}}
        @variant="unstyled"
        class="u--text--success u--p__0 u--m__0"
      />
    {{/if}}
  {{/if}}
  */
  {
    "id": "Jt+g9zdL",
    "block": "[[[41,[30,0,[\"isMobileSubscription\"]],[[[41,[30,0,[\"displayMobileUpgrade\"]],[[[1,\"    \"],[10,0],[14,0,\"cIC--card u--m__t__xs\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cIC--cardBody u--p__t__sm\"],[12],[1,\"\\n        \"],[1,[30,0,[\"mobileUpgradeText\"]]],[1,\"\\n        \"],[8,[39,1],[[16,\"onClick\",[30,0,[\"openMobileRedirectModal\"]]]],[[\"@class\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[28,[37,2],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[41,[28,[37,3],[[30,0,[\"canAddSocialSets\"]]],null],[[[1,\"    \"],[8,[39,4],null,[[\"@additional\",\"@feature\",\"@location\",\"@variant\"],[\"block\",\"addSocialSets\",\"account social sets\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,1],[[24,0,\"u--text--success u--p__0 u--m__0\"]],[[\"@additional\",\"@onClick\",\"@variant\"],[\"block\",[30,1],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"canTrialPlan\"]],[[[1,\"          \"],[1,[28,[35,2],[\"account.groups.social_sets.upgrade_trial\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,2],[\"account.groups.social_sets.upgrade\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n    \"]],[1]]]]],[1,\"\\n\"]],[]],[[[41,[28,[37,5],[[30,2],0],null],[[[1,\"    \"],[8,[39,4],[[24,0,\"u--text--success u--p__0 u--m__0\"]],[[\"@additional\",\"@feature\",\"@location\",\"@text\",\"@variant\"],[\"block\",\"socialSet\",\"account social sets\",[28,[37,2],[\"account.groups.social_sets.add_more\"],null],\"unstyled\"]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]]],[\"upgradeAction\",\"@socialSetsRemaining\"],false,[\"if\",\"shared/ui/button\",\"t\",\"not\",\"shared/button/upgrade\",\"eq\"]]",
    "moduleName": "settings/components/social-set-upgrade.hbs",
    "isStrictMode": false
  });
  let SocialSetUpgradeComponent = _exports.default = (_class = class SocialSetUpgradeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
    }
    get displayMobileUpgrade() {
      return this.subscriptions.canUpgrade && (this.args.socialSetsRemaining === 0 || !this.canAddSocialSets);
    }
    get canAddSocialSets() {
      return Boolean(this.subscriptions.subscriptionPlan?.canAddSocialSets);
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get subscriptionPlatform() {
      return this.subscriptions.platform;
    }
    get mobileUpgradeText() {
      return this.subscriptions.isEligibleForTrial ? this.intl.t('plans.mobile.add_social_sets_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.add_social_sets', {
        platform: this.subscriptionPlatform
      });
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialSetUpgradeComponent);
});